import {
  USER_PINCODE,
  SAVE_LEAD,
  LEAD_LIST,
  STATE_LIST,
  CREATED_BY_LIST,
  BRAND_LIST,
  LOAN_PRODUCT,
  LOAN_PURPOSE,
  REJECT,
  REJECT_REASONS_CATEGORY,
  REJECT_REASONS_SUB_CATEGORY,
} from '../../resources/endPoint';
export const pinCode = data => {
  return {
    url: USER_PINCODE,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'master-service',
  };
};

export const saveLead = data => {
  return {
    url: SAVE_LEAD,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'lead-management-service',
  };
};

export const leadList = data => {
  return {
    url: LEAD_LIST,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'lead-management-service',
  };
};

export const stateList = () => {
  return {
    url: STATE_LIST,
    method: 'get',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'master-service',
  };
};
export const branchList = data => {
  return {
    url: BRAND_LIST,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'master-service',
  };
};
export const createdByList = data => {
  return {
    url: CREATED_BY_LIST,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const leadDropdown = data => {
  return {
    url: LOAN_PRODUCT,
    payload: data,
    method: 'post',
    tag: 'FETCH_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const rejectReasonsCategoryDropdown = data => {
  return {
    url: REJECT_REASONS_CATEGORY,
    payload: data,
    method: 'post',
    tag: 'FETCH_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const loanPurpose = data => {
  return {
    url: LOAN_PURPOSE,
    payload: data,
    method: 'post',
    tag: 'FETCH_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const rejectReasonsSubCatDD = data => {
  return {
    url: REJECT_REASONS_SUB_CATEGORY,
    payload: data,
    method: 'post',
    tag: 'FETCH_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const leadReject = data => {
  return {
    url: REJECT,
    payload: data,
    method: 'post',
    tag: 'FETCH_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'lead-management-service',
  };
};
